export default __webpack_public_path__ + "static/media/gmail-icon.2ed3e711.svg";